import store from "@utils/store/cookie";
import localStorage from "@utils/store/localStorage";
import {
  getUserInfo
} from "@api/user";
import dialog from "@utils/dialog";

const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  userInfo: null,
  storeItems: store.get("storeItems") || null,
  goName: store.get("goName") || "",
  userCategory: store.get("userCategory") || 1,
  isFirst: store.get("isFirst") || 0,
  isFree: store.get("isFree") || false,
  isSign: store.get("isSign") || 0,//是否签约状态
  phone: store.get("phone") || 0,
  productIds:[],
  dictObj: {},
  addressObject: null,
  addressOption: [],
  isRefreshNum: 0,
  isRefreshCustomerNum: 0,
  isRefreshBuyNum: 0,
  firstNumber: localStorage.get("firstNumber") ? Number(localStorage.get("firstNumber")) : 1,

  socket: null
};

const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, token, expires_time) {
    store.set(LOGIN_KEY, token, expires_time);
    state.token = token;
  },
  SET_USER(state, info) {
    state.userCategory = info.userCategory;
    state.isFirst = info.isFirst || 0;
    state.isFree = info.free || false;
    state.isSign = info.isSign || 0;
    state.phone = info.phone || 0;
     // 新增 productIds 处理逻辑
     state.productIds = (Array.isArray(info.productIds) && info.productIds.length)
     ? info.productIds
     : [];
    store.set("userCategory", info.userCategory);
    store.set("isFirst", state.isFirst);
    store.set("isFree", state.isFree);
    store.set("isSign", state.isSign);
    store.set("productIds", state.productIds);
    store.set("phone", state.phone);
  },
  LOGOUT(state) {
    state.token = undefined;
    store.remove(LOGIN_KEY);
    store.remove("userCategory");
    store.remove("isFirst");
    store.remove("isFree");
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  GET_STORE(state, storeItems) {
    state.storeItems = storeItems;
    store.set("storeItems", storeItems);
  },
  GET_TO(state, goName) {
    state.goName = goName;
    store.set("goName", goName);
  },
  SET_DICT(state, dictObj) {
    state.dictObj = dictObj;
  },
  SET_CITY(state, addressOption) {
    state.addressOption = addressOption;
  },
  SET_CITY_OBJECT(state, address) {
    state.addressObject = address;
  },
  SET_REFRESH_NUM(state, num) {
    state.isRefreshNum = num;
  },
  // 设置客户订单数
  SET_REFRESH_CUSTOMER_NUM(state, num) {
    state.isRefreshCustomerNum = num;
  },
  // 设置购买订单数
  SET_REFRESH_BUY_NUM(state, num) {
    state.isRefreshBuyNum = num;
  },
  SET_FIRST_NUM(state, num) {
    state.firstNumber = num;
    localStorage.set("firstNumber", num)
  },
};

const actions = {
  USERINFO({
    state,
    commit
  }, force) {
    if (state.userInfo !== null && !force)
      return Promise.resolve(state.userInfo);
    else
      return new Promise((reslove) => {
        getUserInfo().then((res) => {
          commit("UPDATE_USERINFO", res.data);
          reslove(res.data);
        });
      }).catch(() => {
        dialog.error("获取信息失败!");
      });
  },
};

export default {
  state,
  mutations,
  actions,
};
